import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get, isNil } from "lodash-es";
import { MeltShopProductionShiftFilter } from "../models/Filters";

export const getShiftByParameters = async (
  parameters: MeltShopProductionShiftFilter,
) => {
  try {
    const sqlParameters = [];
    sqlParameters.push({
      name: "ShiftId",
      value: parameters.shiftId === 0 ? null : parameters.shiftId,
    });
    sqlParameters.push({
      name: "ProductionDate",
      value: JSON.parse(JSON.stringify(parameters.productionDate)),
    });
    const apiService = new MESApiService();
    const resp = await apiService.callV2(
      "[MES].[GetShiftByParameters]",
      sqlParameters,
    );
    if (resp.ok) {
      const data = get(resp, "data.tables[0].rows[0]", {});
      if (data.CurrentProductionDate) {
        return {
          ok: true,
          data: data,
        };
      }
      return {
        ok: true,
        data: get(resp, "data.tables[0].rows[0]", {}),
      };
    }
    return resp;
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

//LMF Processes
export const getProcessesByShift = async (
  shiftId: number,
  deleted: boolean,
) => {
  var sqlParameters = [];
  sqlParameters.push({ name: "ShiftId", value: shiftId });
  sqlParameters.push({ name: "GetDeleted", value: deleted });
  try {
    const apiService = new MESApiService();
    const resp = await apiService.call(
      "[LMF].[GetProcessesByShift]",
      sqlParameters,
    );
    return {
      ok: true,
      data: resp,
    };
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

export const upsertProcess = async (
  processId: number | null,
  ladleOpen: Date | null,
  ladleClose: Date | null,
  isManual: boolean,
  assetId?: number | null,
  ladleCar?: number | null,
  isArriveManual?: boolean,
) => {
  try {
    const apiService = new MESApiService();
    const parameters: spParameter[] = [];

    parameters.push({ name: "ProcessId", value: processId });
    parameters.push({ name: "AssetId", value: assetId || null });
    parameters.push({
      name: "Start",
      value: isNil(ladleOpen) ? null : new Date(ladleOpen).toISOString(),
    });
    parameters.push({
      name: "End",
      value: isNil(ladleClose) ? null : new Date(ladleClose).toISOString(),
    });
    parameters.push({ name: "IsManual", value: isManual });
    if (!isNil(ladleCar)) {
      parameters.push({ name: "LadleCar", value: ladleCar });
    }
    if (!isNil(isArriveManual)) {
      parameters.push({ name: "IsArriveManual", value: isArriveManual });
    }
    return await apiService.callV2("[LMF].[UpsertProcess]", parameters);
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

export const deleteProcess = async (processId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "ProcessId", value: processId });

  const resp = await apiService.callV2("[LMF].[DeleteProcess]", parameters);
  return resp;
};

export const unDeleteProcess = async (processId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "ProcessId", value: processId });
  try {
    return await apiService.callV2("[MS].[UndeleteProcess]", parameters);
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

export const upsertProcessData = async (
  processId: number,
  field: string,
  value: any,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "ProcessId", value: processId });
  parameters.push({ name: field, value: value });
  parameters.push({ name: "IsManual", value: true });

  try {
    return await apiService.callV2("[LMF].[UpsertProcessData]", parameters);
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};

export const linkLMFProcess = async (
  processId: number,
  heatId: number,
  force?: boolean,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "ProcessId", value: processId });
  parameters.push({ name: "HeatId", value: heatId });
  parameters.push({ name: "Force", value: force ?? false });
  parameters.push({ name: "IsHeatIdManual", value: true });
  return await apiService.callV2("[LMF].[LinkProcessToHeat]", parameters);
};
export const unLinkLMFProcess = async (processId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];
  parameters.push({ name: "ProcessId", value: processId });
  return await apiService.callV2("[LMF].[UnlinkProcessToHeat]", parameters);
};

export const searchUnlinkedHeats = async (searchText: string, start: Date) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [];

  parameters.push({
    name: "SearchText",
    value: searchText,
  });

  parameters.push({
    name: "Arrive",
    value: start,
  });
  return await apiService.callV2("[LMF].[SearchUnlinkedHeats]", parameters);
};
